import { render, staticRenderFns } from "./SingleImageUpload.vue?vue&type=template&id=3fc7fccf&scoped=true&"
import script from "./SingleImageUpload.vue?vue&type=script&lang=ts&"
export * from "./SingleImageUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc7fccf",
  null
  
)

export default component.exports